import React, { useContext } from "react";

import { AuthContext } from "../AuthProvider";
import CombinedSchedule from "../components/controlpanel/CombinedSchedule";
import ControlPanelMenu from "../components/controlpanel/ControlPanelMenu";
import HotWaterAutomationStatus from "../components/hotwater/HotWaterAutomationStatus";
import HeatingAutomationStatus from "../components/heating/HeatingAutomationStatus";
import { ScreenContext } from "../ScreenProvider";

const ControlPanel = () => {

    const { esp, espLoading } = useContext(AuthContext);
    const { isMobile } = useContext(ScreenContext);

    return (
        <div className="detail-container">
            <ControlPanelMenu />
            <div className="card ps-1 pe-1">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                    </div>
                </div>
                <div>
                    {!espLoading && !esp && <p>Du har ingen värmestyrningsenhet kopplad till ditt kundkonto.</p>}
                    {esp && (
                        <>
                            <div className={!isMobile ? "d-flex m-2" : ""}>
                                <div className={!isMobile ? "me-5" : ""}>
                                    <HeatingAutomationStatus />
                                </div>
                                <div>
                                    <HotWaterAutomationStatus />
                                </div>
                            </div>
                            <div>
                                <CombinedSchedule />
                            </div>
                        </>
                    )}

                </div>

            </div>
        </div >

    )
}

export default ControlPanel;


